import { Link } from "react-router-dom";

export default function Opzioni(){
    return (
        <div className="nav-bar">
            <Link to="/informazioni" className="hero-btn">Informazioni / Servizi</Link>
            <Link to="/prodotti" className="hero-btn">Prodotti</Link>
            <Link to="/catalogo" className="hero-btn">Catalogo</Link>
            <Link to="/contattaci" className="hero-btn">Contattaci</Link>
        </div>
    )
}